<template>
<div class="chapter">
<div class="inner_page">
<div class="fm">
<p class="nonindent" id="fm">To disguise nothing, to conceal nothing, to write about those things that are the closest to your pain, your happiness, to write about my sexual clumsiness, the agonies of Tantalus, the depths of my discouragement…. To write about the foolish agonies of anxiety, the refreshment of your strength when these are ended; to write about the painful search for self….</p>
<p class="right">—J<span class="small">OHN</span> C<span class="small">HEEVER</span><br/><br/><br/></p>
<p class="nonindent">In the heart of each man there is contrived by desperate devices a magical island. We place it in the past or future for safety, for we dare not locate it in the present. We call this memory or a vision to lend it validity, but it is neither, really. It is the outcome of our sadness, and of our disgust with the world that we’ve made.</p>
<p class="right">—E. M. F<span class="small">ORSTER</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062029300_epub_fm_r1.vue?1ad04d8e